//#region lib/utils/colors.ts
var e = [
	"orange",
	"sand",
	"green",
	"red",
	"amber",
	"blue",
	"crimson",
	"plum",
	"violet",
	"indigo",
	"sky",
	"teal",
	"lime",
	"brown",
	"yellow"
];
function t(t) {
	return e.includes(t);
}
var n = [
	1,
	2,
	3,
	4,
	5,
	6,
	7,
	8,
	9,
	10,
	11,
	12
], r = e.flatMap((e) => n.map((t) => `--ag-${e}-${String(t)}`));
function i(e) {
	return e.startsWith("--ag-") && r.includes(e);
}
var a = [
	"accent",
	"neutral",
	"success",
	"error",
	"warning",
	"info",
	"crimson",
	"plum",
	"violet",
	"indigo",
	"sky",
	"teal",
	"lime",
	"brown",
	"yellow"
];
function o(e) {
	return a.includes(e);
}
var s = [
	"background-1",
	"background-2",
	"interactive-default",
	"interactive-hover",
	"interactive-selected",
	"border-not-interactive",
	"border-interactive",
	"border-focus",
	"solid-default",
	"solid-hover",
	"text",
	"text-high-contrast"
], c = a.flatMap((e) => s.map((t) => `--ag-${e}-${t}`));
function l(e) {
	return e.startsWith("--ag-") && c.includes(e);
}
function u(t) {
	return o(t) ? e[a.indexOf(t)] : t;
}
function d(n) {
	return t(n) ? a[e.indexOf(n)] : n;
}
var f = ["white", "black"];
function p(e) {
	return f.includes(e);
}
var m = f.map((e) => `--ag-${e}`);
function h(e) {
	return e.startsWith("--ag-") && m.includes(e);
}
function g(e) {
	try {
		return globalThis.window.getComputedStyle(globalThis.document.documentElement).getPropertyValue(e).trim() || `var(${e})`;
	} catch {
		return `var(${e})`;
	}
}
//#endregion
export { a as COLOR_LEXICAL_NAMES, c as COLOR_LEXICAL_VARS, e as COLOR_NAMES, n as COLOR_NUMBERS, s as COLOR_SUFFIXES_LEXICAL, f as COLOR_UTILITY, m as COLOR_UTILITY_VARS, r as COLOR_VARS, o as isColorLexicalName, l as isColorLexicalVar, t as isColorName, p as isColorUtility, h as isColorUtilityVar, i as isColorVar, d as normalizeColorLexicalName, u as normalizeColorName, g as resolveColorVar };
